import React from "react";
import moment, { isMoment } from "moment";
import { Row, Radio, Modal } from "antd";
import { intersection } from "lodash";

const { confirm } = Modal;

export const DAILY = "Daily";
export const WEEKLY = "Weekly";
export const MONTHLY = "Monthly";
export const QUARTERLY = "Quarterly";
export const BIANNUALLY = "Bi-Annually";
export const YEARLY = "Yearly";
export const ASNEEDED = "AsNeeded";

export const REPORT_TYPES = [
  { ReportType: DAILY, label: DAILY },
  { ReportType: WEEKLY, label: WEEKLY },
  { ReportType: MONTHLY, label: MONTHLY },
  { ReportType: QUARTERLY, label: QUARTERLY },
  { ReportType: BIANNUALLY, label: BIANNUALLY }, // TODO: bi-annually changes
  { ReportType: YEARLY, label: YEARLY },
  { ReportType: ASNEEDED, label: ASNEEDED },
];

export const SOURCELIST = [
  "Batch",
  "Bulk",
  "Email",
  "ULP",
  "FTP",
  // "ImageSilo",
  // "Manual",
  "Portal",
  "SFTP",
  "Virtual Printer",
  "Portal_Bulk",
  "BOT",
];

export const REPORT_FILE_EXTENSIONS = [
  "pdf",
  "rtf",
  "txt",
  "csv",
  "xls",
  "xlsx",
  "tif",
  "tiff",
];

export const MYDOCS_REPORT_TYPES = ["System", "Bulk", "Batch"];

export const REPORT_NAME_MATCHING_CONDITIONS = ["Exact", "Contains", "Regex"];

const weekdays = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

const monthList = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const overideSolutions = [
  { value: "MYP", label: "MYP" },
  // { value: "PNA", label: "PNA" },
];

export const getFileExtensionsBySignatureType = (signatureType) => {
  if (signatureType === "2") {
    return ["pdf", "rtf", "txt"];
  }
  return REPORT_FILE_EXTENSIONS;
};

export const getOverrideSolution = (
  projectSolution,
  solutionSet = overideSolutions,
) => solutionSet.filter((solution) => solution.value !== projectSolution);

export const nth = (num) => {
  const intval = parseInt(num, 10);
  if (intval > 3 && intval < 21) return "th";
  switch (intval % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const getParentStr = (parentData) => {
  const defaultNoText = "Default - No";
  let val = "No";

  switch (parentData?.type) {
    case 1:
      val = "Yes";
      break;
    case 0:
      break;
    default:
      return defaultNoText;
  }
  switch (parentData?.retrieved) {
    case "project":
      return `Project - ${val}`;
    case "hmg":
      return `HMG - ${val}`;
    case "hotel":
      return `Hotel - ${val}`;
    default:
      return defaultNoText;
  }
};

export const getParentRelationValue = (type, parentData) => {
  switch (type) {
    case 1:
      return "Yes";
    case 0:
      return "No";
    case 2:
      return getParentStr(parentData);
    default:
      return "";
  }
};

export const showConfirm = (message) => {// TODO: write common async confirm element
  return new Promise((resolve, reject) => {
    const content =
      message ||
      "The report is QC ignored, do you still want to show it in Compliance?";
    confirm({
      content,
      onOk() {
        resolve(true);
      },
      onCancel() {
        resolve(false);
      },
      icon: null,
    });
  });
};

export const getMaxDate = (frequency, month) => {
  let max = 30;
  if (frequency === YEARLY && month !== undefined) {
    if (month.toString() === "2") {
      max = 28;
    } else {
      const dt = moment().month(parseInt(month, 10) - 1);
      if (isMoment(dt)) {
        max = dt.daysInMonth();
      }
    }
  }
  return max;
};

export const generateMonthDates = (frequency, month) => {
  const max = getMaxDate(frequency, month);
  // console.log(frequency,month,max)

  const retelm = [];
  for (let week = 0; week <= 4; week++) {
    const weekdays = [];
    for (let initval = week * 7 + 1; initval <= week * 7 + 7; initval++) {
      if (initval <= max) {
        weekdays.push(
          <Radio.Button
            key={initval}
            style={{ width: 48 }}
            value={initval.toString()}
          >
            {initval}
          </Radio.Button>,
        );
      }
    }
    retelm.push(<Row key={week}>{weekdays}</Row>);
  }
  return retelm;
  // for (let index = 1; index <= max; index++) {

  // }
};

export const getmodalMessage = (modaldate) => {
  const months = [];
  switch (modaldate) {
    case 29:
    case 30:
      months.push("february");
      break;
    case 31:
      months.push("february");
      months.push("april");
      months.push("june");
      months.push("september");
      months.push("november");
      break;
    default:
  }
  return months.length > 0 ? `${months.join(", ")} will be skipped` : "";
};

export const getScheduleVal = (record, inptyp = null) => {
  if (record.schedule_trigger_type === 2) {
    if (typeof record.schedule_weekday === "string") {
      const vals = record.schedule_weekday.split("_");
      if (record.shedule_type === QUARTERLY || record.shedule_type === YEARLY) {
        if (inptyp == 1 && vals[1] !== undefined) {
          return vals[1];
        }
        if (inptyp == 2 && vals[2] !== undefined) {
          return vals[2];
        }
        if (inptyp == 3 && vals[0] !== undefined) {
          return vals[0];
        }
      } else {
        if (inptyp == 1 && vals[0] !== undefined) {
          return vals[0];
        }
        if (inptyp == 2 && vals[1] !== undefined) {
          return vals[1];
        }
      }
    }
  } else if (record.schedule_trigger_type === 1) {
    if (typeof record.schedule_weekday === "string") {
      const vals = record.schedule_weekday.split("_");
      if (record.shedule_type === QUARTERLY || record.shedule_type === YEARLY) {
        if (inptyp == 3 && vals[0] !== undefined) {
          return vals[0];
        }
        if (inptyp === 4 && vals[1] !== undefined) {
          return vals[1];
        }
      }
      return record.schedule_weekday;
    }
  }
  return undefined;
};

const getScheduleText = (value, type, frequency) => {
  if (value) {
    switch (type) {
      case "month":
        if (frequency === QUARTERLY) {
          return `${value}${nth(value)} month`;
        }
        if (frequency === YEARLY || frequency === BIANNUALLY) {
          return moment()
            .month(parseInt(value) - 1)
            .format("MMMM");
        }
        break;
      case "week":
        return `${value}${nth(value)} week`;
      case "day":
        return value;
      case "date":
        if (value === "lastday") {
          return "last day";
        }
        return value;
      default:
        break;
    }
  }
  return "";
};

export const getScheduleContent = (record) => {
  if (
    record.schedule_trigger_type === 1 ||
    record.schedule_trigger_type === 2
  ) {
    const processedElmArray = [];
    const monthval = getScheduleText(
      getScheduleVal(record, 3),
      "month",
      record.shedule_type,
    );
    const week = getScheduleText(
      getScheduleVal(record, 1),
      "week",
      record.shedule_type,
    );
    const day = getScheduleText(
      getScheduleVal(record, 2),
      "day",
      record.shedule_type,
    );
    const date = getScheduleText(
      getScheduleVal(record, 4),
      "date",
      record.shedule_type,
    );

    if (record.schedule_trigger_type === 1) {
      processedElmArray.push(monthval, date);
    } else if (record.schedule_trigger_type === 2) {
      processedElmArray.push(monthval, week, day);
    }
    return processedElmArray.filter(Boolean).join(" ");
  }
  if (
    record.schedule_trigger_type === 3 ||
    record.schedule_trigger_type === 4
  ) {
    if (Array.isArray(record.schedule_trigger_data)) {
      return record.schedule_trigger_data
        .map((schedule) => {
          const processedElmArray = [];
          const monthval = getScheduleText(
            schedule.month,
            "month",
            record.shedule_type,
          );
          const week = getScheduleText(
            schedule.week,
            "week",
            record.shedule_type,
          );
          const day = getScheduleText(schedule.day, "day", record.shedule_type);
          const date = getScheduleText(
            schedule.date,
            "date",
            record.shedule_type,
          );

          if (record.schedule_trigger_type === 3) {
            processedElmArray.push(monthval, date);
          } else if (record.schedule_trigger_type === 4) {
            processedElmArray.push(monthval, week, day);
          }
          return processedElmArray.filter(Boolean).join(" ");
        })
        .join(", ");
    }
  }

  return typeof record.schedule_weekday === "string"
    ? record.schedule_weekday
    : "";
};

export const getAvailableDocTypes = ({
  hotelData,
  selectedHotels,
  documentTypes,
}) => {
  const selected = Array.isArray(selectedHotels) ? selectedHotels : [];
  const hotelList = Array.isArray(hotelData)
    ? hotelData.filter((hotel) => selected.includes(hotel?._id))
    : [];
  const commonPms = hotelList.map((el) =>
    Array.isArray(el?.pms)
      ? el.pms.map((rt) => rt?.pms_id?.pms_name.toUpperCase())
      : [],
  );
  const availablePms = intersection(...commonPms);
  return documentTypes.filter((doc) =>
    availablePms.includes(doc.pms.toUpperCase()),
  );
};

export const getScheduleTriggerTypes = (frequecy) => {
  const options = [];

  if (frequecy === MONTHLY || frequecy === QUARTERLY || frequecy === YEARLY) {
    options.push(
      { label: "Date of Month", value: 1 },
      { label: "Week of Month", value: 2 },
    );
  }

  if (frequecy === BIANNUALLY) {
    options.push(
      { label: "Custom Date of Month", value: 3 },
      { label: "Custom Week of Month", value: 4 },
    );
  }

  return options;
};

export const getScheduleTriggerTypeText = (type) => {
  switch (type) {
    case 1:
      return "Date of Month";
    case 2:
      return "Week of Month";
    case 3:
      return "Custom Date of Month";
    case 4:
      return "Custom Week of Month";
    default:
      return "";
  }
};

export const getMaxScheduleCount = (reportType) => {
  switch (reportType) {
    case BIANNUALLY:
      return 2;
    default:
      return 1;
  }
};

export const convertReportFieldsToText = (
  report,
  {
    projectReportCategories = [],
    projectSmartScanData = {},
    documentTypes = [],//review
    hotelSubHeaderData = {},//review
  },
) => {
  return {
    ...report,
    report_category: projectReportCategories
      .filter((cat) => {
        return report.report_category.includes(cat._id);
      })
      .map((el) => el.name)
      .join(", "),
    PMSReportName: report.PMSReportName ?? "",
    signature_type:
      report.signature_type === "1" ? "Non-Signature" : "Signature Required",
    ReportOrder: report.ReportOrder ?? "",
    SignatureMandatory:
      typeof report.SignatureMandatory === "boolean"
        ? report.SignatureMandatory.toString()
        : "",
    smart_scan_type: getParentRelationValue(
      report.smart_scan_type,
      projectSmartScanData,
    ),
    enable_redaction:
      typeof report.enable_redaction === "boolean"
        ? report.enable_redaction.toString()
        : "",
    export_flat_files:
      typeof report.export_flat_files === "boolean"
        ? report.export_flat_files.toString()
        : "",
    split_by_sub_header: getParentRelationValue(
      report.split_by_sub_header,
      hotelSubHeaderData,
    ),
    document_type: Array.isArray(report.document_type)
      ? documentTypes
          .filter((el) => report.document_type.includes(el._id))
          .map(
            (docType) =>
              `${docType.documentTitle}_${docType.migDocumentTypeId}`,
          )
          .join(", ")
      : "",
    schedule_trigger_type: getScheduleTriggerTypeText(
      report.schedule_trigger_type,
    ),
    // ["Weekly", "Monthly", "Quarterly", "Yearly"].includes(type)
    schedule_weekday: getScheduleContent(report),
    // TODO: Bi-annual changes
    schedule_trigger_data: [BIANNUALLY].includes(report.shedule_type)
      ? getScheduleContent(report)
      : "",
    schedule_months: Array.isArray(report.schedule_months)
      ? report.schedule_months.join(", ")
      : "",
    mydocs_report_type: report.mydocs_report_type ?? "",
    business_date:
      report.business_date == 0
        ? "Current Date"
        : report.business_date == -1
        ? "Current Date - 1"
        : "",
    emailSubjects: Array.isArray(report.emailSubjects)
      ? report.emailSubjects.join(", ")
      : "",
    filenames: Array.isArray(report.filenames)
      ? report.filenames.join(", ")
      : "",
    FileExtension: Array.isArray(report.FileExtension)
      ? report.FileExtension.join(", ")
      : "",
    FileMappingName: report.FileMappingName ?? "",
    QC_IgnoredReport:
      typeof report.QC_IgnoredReport === "boolean"
        ? report.QC_IgnoredReport.toString()
        : "",
    ComplianceEnabled:
      typeof report.ComplianceEnabled === "boolean"
        ? report.ComplianceEnabled.toString()
        : "",
    report_name_matching_condition: report.report_name_matching_condition ?? "",
    file_extension_mapping:
      typeof report.file_extension_mapping === "boolean"
        ? report.file_extension_mapping.toString()
        : "",
    activation_date: report.activation_date
      ? moment(report.activation_date).local().format("YYYY-MM-DD")
      : "",
    deactivation_date: report.deactivation_date
      ? moment(report.deactivation_date).local().format("YYYY-MM-DD")
      : "",
    signature_activation_date: report.signature_activation_date
      ? moment(report.signature_activation_date).local().format("YYYY-MM-DD")
      : "",
    signature_deactivation_date: report.signature_deactivation_date
      ? moment(report.signature_deactivation_date).local().format("YYYY-MM-DD")
      : "",
    report_type: report?.report_type ?? "",
    create_by: report?.create_by?.name ?? "",
    create_at: report.create_at
      ? moment(report.create_at).local().format("YYYY-MM-DD HH:mm:ss")
      : "",
    update_by: report?.update_by?.name ?? "",
    update_at: report.update_at
      ? moment(report.update_at).local().format("YYYY-MM-DD HH:mm:ss")
      : "",
  };
};

export const preProcessReportSubmitData = (report) => {
  return {
    activation_date: moment.isMoment(report.activation_date)
      ? moment.utc(report.activation_date.format("YYYY-MM-DD"), "YYYY-MM-DD")
      : report.activation_date,
    deactivation_date: moment.isMoment(report.deactivation_date)
      ? moment.utc(report.deactivation_date.format("YYYY-MM-DD"), "YYYY-MM-DD")
      : report.deactivation_date,
    signature_activation_date: moment.isMoment(report.signature_activation_date)
      ? moment.utc(
          report.signature_activation_date.format("YYYY-MM-DD"),
          "YYYY-MM-DD",
        )
      : report.signature_activation_date,
    signature_deactivation_date: moment.isMoment(
      report.signature_deactivation_date,
    )
      ? moment.utc(
          report.signature_deactivation_date.format("YYYY-MM-DD"),
          "YYYY-MM-DD",
        )
      : report.signature_deactivation_date,
  };
};

export const generateDefaultReportObj = (scheduletype) => {
  const dataElement = {
    ReportName: "",
    PMSReportName: "",
    report_category: [],
    signature_type: undefined,
    ReportOrder: undefined,
    SignatureMandatory: false,
    smart_scan_type: 2,
    enable_redaction: false,
    export_flat_files: false,
    split_by_sub_header: 2,
    document_type: [],
    business_date: "-1",
    SourceType: undefined,
    filenames: [],
    FileMappingName: "",
    FileExtension: [],
    QC_IgnoredReport: false,
    // ComplianceEnabled: false,
    ComplianceEnabled: scheduletype !== ASNEEDED,
    activation_date: undefined,
    deactivation_date: undefined,
    signature_activation_date: undefined,
    signature_deactivation_date: undefined,
    shedule_type: scheduletype,
  };
  if ([MONTHLY, QUARTERLY].includes(scheduletype)) {
    dataElement.schedule_trigger_type = undefined;
  }
  if ([WEEKLY, MONTHLY, QUARTERLY, YEARLY].includes(scheduletype)) {
    dataElement.schedule_weekday = undefined;
  }
  if ([MONTHLY, QUARTERLY, YEARLY].includes(scheduletype)) {
    dataElement.schedule_months = [];
  }

  return dataElement;
}

export const preProcessReportExcelData = (
  dataset,
  type,
  {
    ishotelreports = false,
    reportCategories = [],
    projectSolution = "PNA",
    documentTypes = [],
  },
) => {
  if (dataset.length > 1) {
    const retdata = [];
    const indexes = dataset[0];

    for (let index = 1; index < dataset.length; index++) {
      const repelm = generateDefaultReportObj(type);
      const exlelement = dataset[index];

      let countTwo = 0;
      const sendObject = {};
      indexes.forEach((b) => {
        sendObject[b] = exlelement[countTwo];
        countTwo++;
      });

      // console.log(sendObject,'send obj')
      if (
        typeof sendObject["Report Name"] === "string" &&
        sendObject["Report Name"].length > 0
      ) {
        repelm.ReportName = sendObject["Report Name"];
      }
      if (
        typeof sendObject["PMS Report Name"] === "string" &&
        sendObject["PMS Report Name"].length > 0
      ) {
        repelm.PMSReportName = sendObject["PMS Report Name"];
      }
      if (
        typeof sendObject["File Mapping Name"] === "string" &&
        sendObject["File Mapping Name"].length > 0
      ) {
        repelm.FileMappingName = sendObject["File Mapping Name"];
      }
      repelm.FileExtension = REPORT_FILE_EXTENSIONS.includes(
        sendObject["File Extension"],
      )
        ? [sendObject["File Extension"]]
        : [];
      // if (
      //   typeof sendObject["File Extension"] === "string" &&
      //   sendObject["File Extension"].length > 0
      // ) {
      //   repelm.FileExtension = sendObject["File Extension"].split(",");
      // }
      if (SOURCELIST.includes(sendObject["Source Type"])) {
        repelm.SourceType = sendObject["Source Type"];
      }
      if (MYDOCS_REPORT_TYPES.includes(sendObject["myDocs Report Type"])) {
        repelm.mydocs_report_type = sendObject["myDocs Report Type"];
      }
      if (
        typeof sendObject.Subjects === "string" &&
        sendObject.Subjects.length > 0
      ) {
        repelm.emailSubjects = sendObject.Subjects.split(",");
      }
      if (
        typeof sendObject["File Names"] === "string" &&
        sendObject["File Names"].length > 0
      ) {
        repelm.filenames = sendObject["File Names"].split(",");
      }
      if (
        typeof sendObject["Signature Type"] === "string" &&
        sendObject["Signature Type"].length > 0
      ) {
        if (sendObject["Signature Type"] === "Signature Required") {
          repelm.signature_type = "2";
          if (typeof sendObject["Report Order"] === "number") {
            repelm.ReportOrder = parseInt(sendObject["Report Order"]);
          }
          repelm.SignatureMandatory =
            sendObject["Signature Mandatory"].toLowerCase() === "yes";
        } else if (sendObject["Signature Type"] === "Non-Signature") {
          repelm.signature_type = "1";
          repelm.SignatureMandatory = false;
          repelm.signature_activation_date = undefined;
          repelm.signature_deactivation_date = undefined;
        }
      }
      if (
        typeof sendObject["Business Date"] === "string" &&
        sendObject["Business Date"].length > 0
      ) {
        repelm.business_date =
          sendObject["Business Date"] === "Current Date" ? "0" : "-1";
      }
      // // report category
      let rptlist = [];
      if (
        typeof sendObject["Report Category"] === "string" &&
        sendObject["Report Category"].length > 0
      ) {
        rptlist = sendObject["Report Category"].split(",");
      }
      repelm.report_category = reportCategories
        .filter((el) => rptlist.includes(el.name))
        .map((el) => el._id);

      // , 'monthly', 'quarterly' - currently these have different schedule methods
      if (
        [WEEKLY, YEARLY].includes(type) &&
        typeof sendObject.Schedule === "string" &&
        sendObject.Schedule.length > 0
      ) {
        repelm.schedule_weekday = weekdays.includes(sendObject.Schedule)
          ? sendObject.Schedule
          : undefined;
      }

      if (
        typeof sendObject["Schedule Type"] === "string" &&
        sendObject["Schedule Type"].length > 0
      ) {
        if ([MONTHLY, QUARTERLY, YEARLY].includes(type)) {
          switch (sendObject["Schedule Type"]) {
            case "Date of Month":
              repelm.schedule_trigger_type = 1;
              break;
            case "Week of Month":
              repelm.schedule_trigger_type = 2;
              break;
            default:
          }
        }
        if (type === BIANNUALLY) {
          switch (sendObject["Schedule Type"]) {
            case "Custom Date of Month":
              repelm.schedule_trigger_type = 3;
              break;
            case "Custom Week of Month":
              repelm.schedule_trigger_type = 4;
              break;
            default:
          }
        }
      }

      if (repelm.schedule_trigger_type) {
        // set schedule
        let date;
        let week;
        let weekday;
        switch (repelm.schedule_trigger_type) {
          case 1:
            if (
              typeof sendObject["Date/Weekday"] === "number" &&
              sendObject["Date/Weekday"] >= 1 &&
              sendObject["Date/Weekday"] <= 31
            ) {
              date = parseInt(sendObject["Date/Weekday"]);
            } else if (sendObject["Date/Weekday"] === "last day") {
              date = "lastday";
            }
            break;
          case 2:
            if (
              typeof sendObject.Week === "number" &&
              sendObject.Week >= 1 &&
              sendObject.Week <= 4 &&
              weekdays.includes(sendObject["Date/Weekday"])
            ) {
              week = parseInt(sendObject.Week);
              weekday = sendObject["Date/Weekday"];
            }
            break;
          default:
        }

        switch (type) {
          case MONTHLY:
            repelm.schedule_weekday = date
              ? `${date}`
              : week && weekday
              ? `${week}_${weekday}`
              : undefined;
            break;
          case QUARTERLY: {
            const quarterMonth =
              typeof sendObject["Month of Quarter"] === "number" &&
              sendObject["Month of Quarter"] >= 1 &&
              sendObject["Month of Quarter"] <= 3
                ? parseInt(sendObject["Month of Quarter"])
                : undefined;
            repelm.schedule_weekday =
              quarterMonth && date
                ? `${quarterMonth}_${date}`
                : quarterMonth && week && weekday
                ? `${quarterMonth}_${week}_${weekday}`
                : undefined;
            break;
          }
          case YEARLY: {
            const yearlyMonth = monthList.includes(sendObject.Month)
              ? monthList.findIndex((month) => month === sendObject.Month) + 1
              : undefined;
            repelm.schedule_weekday =
              yearlyMonth && date
                ? `${yearlyMonth}_${date}`
                : yearlyMonth && week && weekday
                ? `${yearlyMonth}_${week}_${weekday}`
                : undefined;
            break;
          }
          case BIANNUALLY: {
            repelm.schedule_trigger_data = new Array(
              getMaxScheduleCount(BIANNUALLY),
            )
              .fill(null)
              .map((_, arrIndex) => {
                const monthVal = monthList.includes(
                  sendObject[`Month ${arrIndex + 1}`],
                )
                  ? monthList.findIndex(
                      (month) => month === sendObject[`Month ${arrIndex + 1}`],
                    ) + 1
                  : undefined;
                if (repelm.schedule_trigger_type === 3) {
                  if (
                    typeof sendObject[`Date/Weekday ${arrIndex + 1}`] ===
                      "number" &&
                    sendObject[`Date/Weekday ${arrIndex + 1}`] >= 1 &&
                    sendObject[`Date/Weekday ${arrIndex + 1}`] <= 31
                  ) {
                    date = parseInt(sendObject[`Date/Weekday ${arrIndex + 1}`]);
                  } else if (
                    sendObject[`Date/Weekday ${arrIndex + 1}`] === "last day"
                  ) {
                    date = "lastday";
                  }
                  return monthVal && date ? { month: monthVal, date } : {};
                }
                if (repelm.schedule_trigger_type === 4) {
                  if (
                    typeof sendObject[`Week ${arrIndex + 1}`] === "number" &&
                    sendObject[`Week ${arrIndex + 1}`] >= 1 &&
                    sendObject[`Week ${arrIndex + 1}`] <= 4 &&
                    weekdays.includes(
                      sendObject[`Date/Weekday ${arrIndex + 1}`],
                    )
                  ) {
                    week = parseInt(sendObject[`Week ${arrIndex + 1}`]);
                    weekday = sendObject[`Date/Weekday ${arrIndex + 1}`];
                  }
                  return monthVal && week && weekday
                    ? { month: monthVal, week, weekday }
                    : {};
                }
                return {};
              });
            break;
          }
          default:
        }
      }

      if (typeof sendObject["Smart Scan"] === "string") {
        switch (sendObject["Smart Scan"].toLowerCase()) {
          case "yes":
            repelm.smart_scan_type = 1;
            break;
          case "no":
            repelm.smart_scan_type = 0;
            break;
          default:
        }
      }
      if (typeof sendObject["Generate Redact Files"] === "string") {
        repelm.enable_redaction =
          sendObject["Generate Redact Files"].toLowerCase() === "yes";
      }
      if (typeof sendObject["Generate Flat Files"] === "string") {
        repelm.export_flat_files =
          sendObject["Generate Flat Files"].toLowerCase() === "yes";
      }
      if (typeof sendObject["Split Reports By Sub Header Type"] === "string") {
        switch (sendObject["Split Reports By Sub Header Type"].toLowerCase()) {
          case "parent":
            repelm.split_by_sub_header = 2;
            break;
          case "yes":
            repelm.split_by_sub_header = 1;
            break;
          case "no":
            repelm.split_by_sub_header = 0;
            break;
          default:
        }
      }
      let dtypelist = [];
      if (
        typeof sendObject["Document Type"] === "string" &&
        sendObject["Document Type"].length > 0
      ) {
        dtypelist = sendObject["Document Type"].split(",");
      }
      repelm.document_type = documentTypes
        .filter((el) => dtypelist.includes(el.documentTitle))
        .map((el) => el._id);

      if (typeof sendObject["QC Ignored Report"] === "string") {
        repelm.QC_IgnoredReport =
          sendObject["QC Ignored Report"].toLowerCase() === "yes";
      }
      if (typeof sendObject["Compliance Enabled"] === "string") {
        repelm.ComplianceEnabled =
          sendObject["Compliance Enabled"].toLowerCase() === "yes";
      }
      if (
        REPORT_NAME_MATCHING_CONDITIONS.includes(
          sendObject["Report Name Matching Condition"],
        )
      ) {
        repelm.report_name_matching_condition =
          sendObject["Report Name Matching Condition"];
      }
      if (typeof sendObject["File Extension Mapping"] === "string") {
        repelm.file_extension_mapping =
          sendObject["File Extension Mapping"].toLowerCase() === "yes";
      }

      const activationDate =
        typeof sendObject["Activation Date"] === "object"
          ? moment(sendObject["Activation Date"]).utc().format("YYYY-MM-DD")
          : undefined;
      const deActivationDate =
        typeof sendObject["Deactivation Date"] === "object"
          ? moment(sendObject["Deactivation Date"]).utc().format("YYYY-MM-DD")
          : undefined;
      repelm.activation_date = moment(activationDate, "YYYY-MM-DD").isValid()
        ? moment(activationDate, "YYYY-MM-DD")
        : undefined;
      repelm.deactivation_date = moment(
        deActivationDate,
        "YYYY-MM-DD",
      ).isValid()
        ? moment(deActivationDate, "YYYY-MM-DD")
        : undefined;

      if (
        [MONTHLY, QUARTERLY, YEARLY].includes(type) &&
        typeof sendObject.Month === "string" &&
        sendObject.Month.length > 0
      ) {
        repelm.schedule_months = intersection(
          monthList,
          sendObject.Month.split(","),
        );
      }
      repelm.shedule_type = type; // not required. assigned within addFn

      // if (ishotelreports) {
      //   repelm.hotel_code = sendObject["Hotel Code"];
      // }

      const sigActivationDate =
        typeof sendObject["Signature Activation Date"] === "object"
          ? moment(sendObject["Signature Activation Date"])
              .utc()
              .format("YYYY-MM-DD")
          : undefined;
      const sigDeActivationDate =
        typeof sendObject["Signature Deactivation Date"] === "object"
          ? moment(sendObject["Signature Deactivation Date"])
              .utc()
              .format("YYYY-MM-DD")
          : undefined;
      // change
      if (
        typeof sendObject["Signature Type"] === "string" &&
        sendObject["Signature Type"].length > 0
      ) {
        if (sendObject["Signature Type"] === "Signature Required") {
          repelm.signature_type = "2";
          repelm.signature_activation_date = moment(
            sigActivationDate,
            "YYYY-MM-DD",
          ).isValid()
            ? moment(sigActivationDate, "YYYY-MM-DD")
            : undefined;
          repelm.signature_deactivation_date = moment(
            sigDeActivationDate,
            "YYYY-MM-DD",
          ).isValid()
            ? moment(sigDeActivationDate, "YYYY-MM-DD")
            : undefined;
        } else if (sendObject["Signature Type"] === "Non-Signature") {
          repelm.signature_type = "1";
          repelm.SignatureMandatory = false;
          repelm.signature_deactivation_date = undefined;
          repelm.signature_activation_date = undefined;
        }
      }
      if (sendObject.Solution) {
        const solutionRecord = getOverrideSolution(projectSolution).find(
          (solution) => solution.value === sendObject.Solution,
        );
        if (solutionRecord) {
          repelm.report_type = solutionRecord.value;
        }
      }

      retdata.push(repelm);
    }
    return retdata;
  }
  return [];
};

export default {
  DAILY,
  WEEKLY,
  MONTHLY,
  QUARTERLY,
  BIANNUALLY,
  YEARLY,
  ASNEEDED,
  REPORT_TYPES,
  SOURCELIST,
  REPORT_FILE_EXTENSIONS,
  generateDefaultReportObj,
  getParentRelationValue,
  showConfirm,
  getmodalMessage,
  getScheduleVal,
  getScheduleContent,
  getAvailableDocTypes,
  getScheduleTriggerTypes,
  getMaxScheduleCount,
  getScheduleTriggerTypeText,
  getMaxDate,
  generateMonthDates,
  convertReportFieldsToText,
  preProcessReportExcelData,
  getOverrideSolution,
};
